module.exports = __webpack_public_path__ + "assets/img/kj_img2.02400d6c.png";